/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import { Col, Row } from "react-bootstrap";

import { APP_COLORS } from "../../../common/Constants";

import styled from "styled-components";
import { CompanyDetailText } from "../../../admin/companies/Company";
import SpendFormatNumber from "../../../admin/companies/components/SpendFormatNumber";

const SpendSection = (props) => {
    const { company } = props;

    const showSpend = (company) => {
        if (company.activity?.categorySpend ||
            company.activity?.jobStarts ||
            company.activity?.activeJobStarts
        ) return true
    }

    if (showSpend(company)) {
        return (
            <MainContainer>
                <Row>
                    <Col xs={4} md={4} lg={4} xl={4}>
                        <div style={{textAlign: 'center', paddingTop: 15}}>
                            <CompanyDetailText fontWeight={'bold'} fontSize={20} color={APP_COLORS['green']}>
                                ${SpendFormatNumber(Math.ceil((company.activity?.categorySpend | 0) / 1000) * 1000)}
                            </CompanyDetailText>
                            <CompanyDetailText fontSize={16}>Total Spend</CompanyDetailText>
                        </div>
                    </Col>
                    <Col xs={4} md={4} lg={4} xl={4}>
                        <div style={{textAlign: 'center', paddingTop: 15}}>
                            <CompanyDetailText fontWeight={'bold'} fontSize={20}>{company.activity?.jobStarts | 0}</CompanyDetailText>
                            <CompanyDetailText fontSize={16}>Total Jobs</CompanyDetailText>
                        </div>
                    </Col>
                    <Col xs={4} md={4} lg={4} xl={4}>
                        <div style={{textAlign: 'center', paddingTop: 15}}>
                            <CompanyDetailText fontWeight={'bold'} fontSize={20}
                                               color={APP_COLORS['orange']}>{company.activity?.activeJobStarts | 0}</CompanyDetailText>
                            <CompanyDetailText fontSize={16}>Active Jobs</CompanyDetailText>
                        </div>
                    </Col>
                </Row>
            </MainContainer>
        );
    }

    return (<></>)
}

export default SpendSection;

const MainContainer = styled.div`
    margin-top: 0;
    margin-bottom: 30px;
`;
